// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid {
  grid-auto-columns: repeat(4, auto);
}
.grid.filters {
  grid-template-columns: repeat(5, auto);
}
.grid.screenings {
  grid-template-columns: repeat(5, auto);
}
.grid.screenings > div:nth-child(10n+6),
.grid.screenings > div:nth-child(10n+7),
.grid.screenings > div:nth-child(10n+8),
.grid.screenings > div:nth-child(10n+9),
.grid.screenings > div:nth-child(10n+10) {
  background-color: rgba(245, 245, 245, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/app/users-module/users/users.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,kCAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAGA;;;;;EAKE,0CAAA;AADF","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid {\n    grid-auto-columns: repeat(4, auto);\n  }\n.grid.filters {\n    grid-template-columns: repeat(5, auto);\n}\n.grid.screenings {\n    grid-template-columns: repeat(5, auto);\n}\n.grid.screenings > div:nth-child(10n+6),\n.grid.screenings > div:nth-child(10n+7),\n.grid.screenings > div:nth-child(10n+8),\n.grid.screenings > div:nth-child(10n+9),\n.grid.screenings > div:nth-child(10n+10){\n  background-color: @grid-row;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
